import { Box, type BoxProps } from "@mui/material"
import {
  AsideSectionSummaryInfo,
  type AsideSectionSummaryInfoProps,
} from "@pharmupp/p3-front-commons"

export const SummaryInfo = ({
  sources,
  period,
  ToolTipContent,
  ...boxProps
}: Omit<AsideSectionSummaryInfoProps, "showSourcesWhenEmpty" | "dateLabel"> &
  BoxProps) => {
  return (
    <Box display="flex" justifyContent="flex-end" {...boxProps}>
      <AsideSectionSummaryInfo
        showSourcesWhenEmpty={false}
        sources={sources}
        period={period}
        ToolTipContent={ToolTipContent}
        dateLabel="Données du "
      />
    </Box>
  )
}
